import React from "react";
import { DocumentSnapshot, User } from "@atgof-firebase/firebase";
import { IdTokenResult } from "firebase/auth";

export type UserState = {
  user: DocumentSnapshot;
  authUser: User;
  emailVerified: boolean;
  idTokenResult: IdTokenResult | undefined;
  logOut: () => void;
};

export const UserContext = React.createContext({} as UserState);
